<template>
  <base-modal size="lg" hide-footer hide-header @close="$emit('close')" no-padding>
    <div class="col-12 p-2" @click.stop="" style="background: #f3f3f7">
      <h1 class="pl-3 pr-2" style="color: #003856">
        {{ $t('delivery_note.title') }}
      </h1>
      <div class="pl-3 pr-3">
        <div class="col-12" style="text-transform: uppercase">
          {{ summaryItem.contract }}
        </div>
        <div class="col-12">
          {{ summaryItem.order ? getOrderAndExecutorStr(summaryItem.order) : '-' }}
        </div>
        <div class="col-12">
          {{ summaryItem.vehicle }}
        </div>
        <div class="col-12">
          {{ summaryItem.driver }}
        </div>
        <div class="col-12">
          {{ summaryItem.delivery_tons.toFixed(2) }} t
        </div>
      </div>

      <div class="col-12 nopads">
        <!-- Tabs -->
        <ul class="nav nav-tabs routa-tabs">
            <li class="nav-item">
                <button class="routa-tab" :class="{ active: activeTab === 1 }" @click="activeTab = 1">
                    {{ $t('daily_summary.notes_list') }}
                </button>
                <div class="routa-tab-indicator"/>
            </li>
            <li class="nav-item">
                <button class="routa-tab" :class="{ active: activeTab === 2 }" @click="activeTab = 2">
                    {{ $t('daily_summary.cost_calculated') }}
                </button>
                <div class="routa-tab-indicator"/>
            </li>
        </ul>
        <!-- Content -->
        <div class="tab-content routa-tab-content">
            <div class="tab-pane fade" :class="{ show: activeTab === 1, active: activeTab === 1 }">
                <delivery-note-list :hide-borders="true" :notes="notes"/>
            </div>
            <div class="tab-pane fade" :class="{ show: activeTab === 2, active: activeTab === 2 }">
                <delivery-note-price-list v-if="notes.length > 0" class="p-1" :notes="notes" :summary-item="summaryItem"/>
            </div>
        </div>
      </div>
      <div class="col-12 nopads pt-3 pr-3 d-flex justify-content-end">
          <button
            class="btn btn-sm btn-secondary form-button"
            @click.stop="$emit('close')"
          >
            {{ $t('common.close') }}
          </button>
      </div>
      <div
        v-if="loading"
        id="loader"
        class="spinner"
      />
    </div>
  </base-modal>
</template>

<script>
import {restApi} from "../mixins/RestApiMixin";
import {timeUtils} from '../mixins/TimeUtils'
import DeliveryNoteList from "@/components/materials/DeliveryNoteList";
import DeliveryNotePriceList from "@/components/materials/DeliveryNotePriceList";
import {orderMixin} from "@/components/mixins/OrderMixin";
import BaseModal from "@/components/BaseModal";


export default {
    name: "ContractTripDeliveries",
    components: {BaseModal, DeliveryNoteList, DeliveryNotePriceList},
    mixins: [restApi, timeUtils, orderMixin],
    props: {
        summaryItem: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            activeTab: 1,
            loading: false,
            notes: []
        }
    },
    mounted() {
        this.fetchDeliveryNotes()
    },
    methods: {
        fetchDeliveryNotes: function () {
            if (this.summaryItem) {
                this.loading++
                this.restFetch(
                    this.tripSummaryUrl + "/" + this.summaryItem.id + "/delivery",
                    this.fetchNotesSuccess,
                    this.fetchFail
                )
            }
        },
        fetchNotesSuccess: function (response) {
            this.notes = response.data
            this.loading--
        },
        fetchFail: function () {
            this.loading = false
        }
    }
}
</script>
<style>
</style>
